import React, { Component } from 'react'
import cover from '../imgs/zine7/cover.png'
import pg1 from '../imgs/zine7/1.png'
import pg2 from '../imgs/zine7/2.png'
import pg3 from '../imgs/zine7/3.png'
import pg4 from '../imgs/zine7/4.png'
import pg5 from '../imgs/zine7/5.png'
import pg6 from '../imgs/zine7/6.png'
import pg7 from '../imgs/zine7/7.png'
import pg8 from '../imgs/zine7/8.png'
import pg9 from '../imgs/zine7/9.png'
import pg10 from '../imgs/zine7/10.png'
import pg11 from '../imgs/zine7/11.png'
import pg12 from '../imgs/zine7/12.png'
import back from '../imgs/zine7/back.png'

var pageStyle = {
  width: "25em"
}

export default class One extends Component {
  render() {
    return (
      <div>
        <div style={{display: "flex", flexFlow: "row wrap", justifyContent: "center", alignItems: "center", backgroundColor: "#fed7ea", background: "white url(https://gdurl.com/zUud) repeat fixed top", backgroundSize: "100vw", overflowX: "hidden"}}>
          {/* <img style={{width: "20em", margin: "3em 0", boxShadow: "-10px 10px #97a8ea"}} src={cover} alt="HMMMM 1" /> */}
          <div style={{backgroundColor: "white", paddingBottom: "2em", marginTop: '3em'}}>
            <img style={pageStyle} src={cover} alt="HMMMM 7" />
            <img style={pageStyle} src={pg1} alt="HMMMM 7" />
            <img style={pageStyle} src={pg2} alt="HMMMM 7" />
            <img style={pageStyle} src={pg3} alt="HMMMM 7" />
            <img style={pageStyle} src={pg4} alt="HMMMM 7" />
            <img style={pageStyle} src={pg5} alt="HMMMM 7" />
            <img style={pageStyle} src={pg6} alt="HMMMM 7" />
            <img style={pageStyle} src={pg7} alt="HMMMM 7" />
            <img style={pageStyle} src={pg8} alt="HMMMM 7" />
            <img style={pageStyle} src={pg9} alt="HMMMM 7" />
            <img style={pageStyle} src={pg10} alt="HMMMM 7" />
            <img style={pageStyle} src={pg11} alt="HMMMM 7" />
            <img style={pageStyle} src={pg12} alt="HMMMM 7" />
            <img style={pageStyle} src={back} alt="HMMMM 7" />
          </div>     
        </div>
      </div>
    )
  }
}
